import {Utils} from './Utils'

export interface ModalConfig {
    window: string;
    container?: string;
}

export class Modal {
    protected isActive: boolean;
    private readonly elements: {
        window: HTMLElement,
        container?: HTMLElement,
        triggers?: NodeListOf<HTMLElement>[]
    };
    protected selectors: {
        window: string,
        container?: string,
        triggers?: string[]
    };

    constructor({window, container}: ModalConfig) {
        this.isActive = false;
        this.selectors = {window, container, triggers: []};
        this.elements = {
            window: document.querySelector(window),
            container: document.querySelector(container),
            triggers: []
        };
        this.init();
    }

    public addTriggers(selector: string): void {
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll(selector);
        if (!this.elements.window || !triggers.length) return;
        this.elements.triggers.push(triggers);
        this.selectors.triggers.push(selector);
        triggers.forEach(trigger => {
            trigger.addEventListener(`click`, (evt) => this.onTriggerClick(evt), false);
        });
    }

    protected onContainerClick(evt: Event): void {
        const target = evt.target as HTMLElement;
        const notWindow = target.closest(this.selectors.window) === null;
        const notTrigger = !this.selectors.triggers.some(trigger => {
            return !(target.closest(trigger) === null);
        });

        if (notWindow && notTrigger) this.close();
    }

    protected onTriggerClick(evt: Event): void {
        evt.preventDefault();
        this.toggle(evt.currentTarget as HTMLElement);
    }

    public close(): void {
        const {window, triggers} = this.elements;
        this.isActive = false;
        Utils.removeClass(window, `is-active`);
        triggers.forEach(nodes => {
            nodes.forEach(node => Utils.removeClass(node, `is-triggered`));
        });
    }

    public toggle(trigger: HTMLElement): void {
        const {window, triggers} = this.elements;
        this.isActive = !this.isActive;
        Utils.toggleClass(window, `is-active`);

        if (this.isActive) {
            Utils.toggleClass(trigger, `is-triggered`);
        } else {
            triggers.forEach(nodes => {
                nodes.forEach(node => Utils.removeClass(node, `is-triggered`));
            });
        }
    }

    protected init(): void {
        const {container} = this.elements;
        if (container) {
            container.addEventListener(`click`, (evt) => this.onContainerClick(evt), false);
        }
    }

    get state(): string {
        return this.isActive ? `opened` : `closed`;
    }
}